var exports = {
  "bE": "FeedPostCard.module__post___dlZoM3",
  "J7": "FeedPostCard.module__pageVariant___dlZoM3",
  "KI": "FeedPostCard.module__avatarButton___dlZoM3",
  "CH": "FeedPostCard.module__authorButton___dlZoM3",
  "Mj": "FeedPostCard.module__moreButton___dlZoM3",
  "hP": "FeedPostCard.module__actionButton___dlZoM3",
  "rf": "FeedPostCard.module__body___dlZoM3",
  "wx": "FeedPostCard.module__header___dlZoM3",
  "Tc": "FeedPostCard.module__tag___dlZoM3",
  "vE": "FeedPostCard.module__timestamp___dlZoM3",
  "N1": "FeedPostCard.module__timestampLink___dlZoM3",
  "qR": "FeedPostCard.module__timestampBeforeMarker___dlZoM3",
  "m7": "FeedPostCard.module__publicMarker___dlZoM3",
  "HG": "FeedPostCard.module__followPill___dlZoM3",
  "gG": "FeedPostCard.module__followPillFollowing___dlZoM3",
  "Wm": "FeedPostCard.module__followHoverLabel___dlZoM3",
  "Ib": "FeedPostCard.module__followIdleLabel___dlZoM3",
  "Qs": "FeedPostCard.module__content___dlZoM3",
  "yn": "FeedPostCard.module__noOpen___dlZoM3",
  "$_": "FeedPostCard.module__media___dlZoM3",
  "o1": "FeedPostCard.module__actions___dlZoM3",
  "gE": "FeedPostCard.module__actionIcon___dlZoM3",
  "bR": "FeedPostCard.module__actionButtonActive___dlZoM3",
  "aB": "FeedPostCard.module__likeButton___dlZoM3",
  "xE": "FeedPostCard.module__actionsEnd___dlZoM3",
  "DC": "FeedPostCard.module__viewCount___dlZoM3",
  "nK": "FeedPostCard.module__comments___dlZoM3",
  "eu": "FeedPostCard.module__commentComposer___dlZoM3",
  "gJ": "FeedPostCard.module__commentComposerInput___dlZoM3",
  "Im": "FeedPostCard.module__comment___dlZoM3",
  "GI": "FeedPostCard.module__blockedComment___dlZoM3",
  "I2": "FeedPostCard.module__commentBody___dlZoM3",
  "NP": "FeedPostCard.module__commentHeader___dlZoM3",
  "Lp": "FeedPostCard.module__commentBadge___dlZoM3",
  "H3": "FeedPostCard.module__commentAuthor___dlZoM3" + " " + "FeedPostCard.module__authorButton___dlZoM3",
  "h5": "FeedPostCard.module__status___dlZoM3",
  "jo": "FeedPostCard.module__sendButton___dlZoM3",
};

module.exports = exports;
